'use client';
import React, { useEffect } from 'react';

import './FactionDiagram.css';
import { useTranslations } from 'next-intl';
import { diagramConfig } from '../diagram.config';
import { formatThousands } from '@wwe-portal/utils/format';
import { Chart } from 'chart.js';
import { diagramDrawer } from '../diagramDrawer';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';

function FactionDiagram({ totalWins, totalLosses, snapShotMonth }) {
  const t = useTranslations();

  useEffect(() => {
    const ctx = (
      document.getElementById('myDiagram') as HTMLCanvasElement
    ).getContext('2d');

    if (Chart.defaults.elements?.Rectangle) {
      Chart.defaults.elements.Rectangle.prototype.draw = diagramDrawer(ctx);
    }
    const gradient = ctx?.createLinearGradient(0, 100, 0, 200);

    gradient?.addColorStop(0, '#00a0ff');
    gradient?.addColorStop(1, '#005fff');

    if (ctx) {
      const datasets =
        totalWins.length || totalLosses.length
          ? [
              {
                data: totalWins,
                borderWidth: 0,
                backgroundColor: gradient,
              },
              {
                data: totalLosses,
                borderWidth: 0,
                backgroundColor: '#7909e2',
                hoverBackgroundColor: '#7909e2',
              },
            ]
          : [
              {
                data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
                borderWidth: 0,
                backgroundColor: '#343961',
              },
            ];

      const options = diagramConfig(
        datasets,
        totalWins?.length && totalLosses?.length ? snapShotMonth : ''
      );
      // eslint-disable-next-line sonarjs/constructor-for-side-effects
      new Chart(ctx, options);
    }
  }, [snapShotMonth, totalLosses, totalWins]);

  return (
    <div className="faction-diagram mt-[30px] hidden w-full flex-col justify-between rounded-[10px] px-10 py-[50px] sm:flex sm:flex-col 2xl:flex-row">
      <div className="faction-diagram-header flex w-full flex-col pt-[10px]">
        <div className="faction-diagram-titles">
          <span className="text-md m-0 p-0 font-medium">
            {t('faction_total_battle_performance')}
          </span>
          <p className="text-text600 m-0 p-0 pt-5 text-sm capitalize">
            {t('last')} {t('12_month')}
          </p>
        </div>
        <hr className="hr-profile faction-diagram-header-hr my-[50px]" />
        <div className="faction-diagram-items flex w-full flex-col justify-end">
          <div className="faction-diagram-items-item mb-[50px] flex items-center">
            <span className="faction-diagram-items-item-icon text-blue700 mr-[15px] rounded-[10px] p-[10px]">
              <IcoMoonIcon iconName="crown" className="size-5" />
            </span>
            <div>
              <p className="text-text600 m-0 p-0 text-sm">
                {t('total_wins')} ({t('12_month')})
              </p>
              <span className="text-text400 m-0 p-0 pt-[5px] text-lg font-medium">
                {formatThousands(totalWins.reduce((acc, cur) => acc + cur, 0))}
              </span>
            </div>
          </div>
          <div className="faction-diagram-items-item flex items-center">
            <span className="faction-diagram-items-item-icon text-purple800 mr-[15px] rounded-[10px] p-[10px]">
              <IcoMoonIcon iconName="honour-fill" className="size-5" />
            </span>
            <div>
              <p className="text-text600 m-0 p-0 text-sm">
                {t('total_losses')} ({t('12_month')})
              </p>
              <span className="text-text400 m-0 p-0 pt-[5px] text-lg font-medium">
                {formatThousands(
                  totalLosses.reduce(
                    (acc, cur) => Math.abs(acc) + Math.abs(cur),
                    0
                  )
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <canvas id="myDiagram" className="faction-diagram-canvas" />
    </div>
  );
}

export default FactionDiagram;
